export default __webpack_public_path__ + "static/first-order-pint-a483306c79a8dab5aa5d91af75a03766.jpg";